module.exports = __webpack_public_path__ + "media/images/form-status-pending-2887c13f.gif";